import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-leilao04',
  templateUrl: './leilao04.component.html',
  styleUrls: ['./leilao04.component.scss']
})
export class Leilao04Component implements OnInit  {
 
  constructor(private route: ActivatedRoute, private router: Router) {}
 
  ngOnInit(){
  }

  voltar(){
    this.router.navigate([''], { relativeTo: this.route });
  }
}

